module.exports = __webpack_public_path__ + "static/media/logo-react.5d5d9eef.svg";